import {combineReducers} from 'redux';

import global from '../states/global';

const rootReducer = combineReducers({
  global
});

export default rootReducer
